// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"Pingfang SC, Microsoft Yahei, sans-serif"};